














































































import Vue from 'vue'
import Icon from '@/components/globals/Icon.vue'
import { buildFacilityPath, Facility, FacilityId } from '@/core/Facilities'
import Stars from '@/components/globals/basics/Rating/Stars.vue'
import FavoriteButton from '@/components/globals/basics/Favorite/FavoriteButton.vue'

export default Vue.extend({
  name: 'FacilityList',
  filters: {
    truncate(str: string, size: number, suffix: string = '…') {
      let b = 0
      for (let i = 0; i < str.length; i++) {
        b += str.charCodeAt(i) <= 255 ? 1 : 2
        if (b > size) {
          return str.substr(0, i) + suffix
        }
      }
      return str
    },
    formatScore(score: number | string) {
      const floatValue = Number(score) - Math.floor(Number(score))
      // 小数点以下がない場合は.0をsuffixする
      return floatValue === 0 ? `${Math.floor(Number(score))}.0` : score
    },
    toFacilityPath(facility: Facility): string {
      return buildFacilityPath(facility)
    },
  },
  components: {
    Icon,
    Stars,
    FavoriteButton,
  },
  props: {
    facilities: {
      type: Array as () => Facility[],
      default: () => [],
    },
    favoritedFacilityIds: {
      type: Array as () => FacilityId[],
      default: () => [],
    },
  },
  methods: {
    handleFavoriteClick(facilityId: FacilityId, favorited: boolean) {
      this.$emit('onFavorited', facilityId, favorited)
    },
  },
})
